var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "disabled": _vm.disabled,
      "elevation": "0"
    }
  }, [_vm.application ? _c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('application-view-row', {
    attrs: {
      "label": "기업명"
    },
    model: {
      value: _vm.inputs.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "companyName", $$v);
      },
      expression: "inputs.companyName"
    }
  }), _c('application-view-row', {
    attrs: {
      "label": "대표자명"
    },
    model: {
      value: _vm.inputs.ceoName,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "ceoName", $$v);
      },
      expression: "inputs.ceoName"
    }
  }), _c('application-view-row', {
    attrs: {
      "label": "사업자등록번호"
    },
    model: {
      value: _vm.inputs.businessNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "businessNumber", $$v);
      },
      expression: "inputs.businessNumber"
    }
  }), _c('application-view-date', {
    attrs: {
      "label": "설립일"
    },
    model: {
      value: _vm.inputs.establishedAt,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "establishedAt", $$v);
      },
      expression: "inputs.establishedAt"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('application-view-row', {
    attrs: {
      "label": "주요생산제품"
    },
    model: {
      value: _vm.inputs.mainProduct,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "mainProduct", $$v);
      },
      expression: "inputs.mainProduct"
    }
  }), _c('application-view-worker', {
    model: {
      value: _vm.inputs,
      callback: function callback($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }), _c('application-view-phone', {
    attrs: {
      "label": "연락처"
    },
    model: {
      value: _vm.inputs.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "phone", $$v);
      },
      expression: "inputs.phone"
    }
  }), _c('application-view-email', {
    attrs: {
      "label": "이메일"
    },
    model: {
      value: _vm.inputs.email,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "email", $$v);
      },
      expression: "inputs.email"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('application-view-address', {
    model: {
      value: _vm.inputs,
      callback: function callback($$v) {
        _vm.inputs = $$v;
      },
      expression: "inputs"
    }
  }), _c('application-view-row', {
    attrs: {
      "label": "홈페이지주소"
    },
    model: {
      value: _vm.inputs.website,
      callback: function callback($$v) {
        _vm.$set(_vm.inputs, "website", $$v);
      },
      expression: "inputs.website"
    }
  })], 1)], 1) : _vm._e()], 1), _vm.application && _vm.application.files ? _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 text-subtitle-1",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 첨부파일 ")]), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-chip-group', {
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.application.files, function (_ref) {
    var _id = _ref._id,
        url = _ref.url,
        fileName = _ref.fileName;
    return _c('v-chip', {
      key: _id,
      attrs: {
        "href": url,
        "outlined": "",
        "color": "secondary",
        "download": ""
      }
    }, [_vm._v(_vm._s(fileName))]);
  }), 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }